import { Link, useParams } from "react-router-dom";
import { STAFF_SECTIONS } from "@/pages/staff/StaffLayout";
import { t } from "@/lib/i18n";

export default function StaffPlaceholder() {
  const { section } = useParams();
  const item = STAFF_SECTIONS.find((s) => s.to === `/staff/${section}`);
  if (!item) {
    return (
      <div data-testid="staff-not-found"><h1 className="text-4xl">{t("common.notFoundTitle")}</h1><Link to="/staff" className="btn-primary mt-6">{t("staff.dashboard")}</Link></div>
    );
  }
  return (
    <div data-testid={`staff-placeholder-${section}`}>
      <h1 className="text-4xl">{t(item.key)}</h1>
      <div className="surface mt-8 max-w-xl p-6">
        <p className="font-serif text-xl font-semibold">{t("staff.comingPhase", { n: item.phase })}</p>
        <p className="mt-2 text-ink-900">This section is part of the build order in the specification and will be delivered with that phase.</p>
        <Link to="/staff" className="btn-secondary mt-5">{t("staff.dashboard")}</Link>
      </div>
    </div>
  );
}
